import React from 'react';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../config/Translate";
import { withSnackbar } from 'notistack';
import BreadCrumbs from "../../components/elements/BreadCrumbs";
import AppAnimate from "../../components/AppAnimate";
import AppCard from "../../components/layouts/components/AppCard";
import Tickets from "./Tickets";
import ManageTickets from "./ManageTickets";


class RequestsPage extends React.Component {
    classes = this.props.classes;
    render(){
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={this.props.manage ? Translate.manageTickets : Translate.tickets}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12}>
                        <AppCard
                            title={this.props.manage ? Translate.manageTickets : Translate.tickets}
                            action={
                                <BreadCrumbs singleLevel firstText={this.props.manage ? Translate.manageTickets : Translate.tickets}/>
                            }>
                            {
                                this.props.manage ?
                                    <ManageTickets manage/> :
                                    <Tickets/>
                            }
                        </AppCard>
                    </Grid>
                </Grid>
            </AppAnimate>
        );
    }
}
export default withSnackbar(withStyles(Styles)(RequestsPage));
